import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";

const KEY = "we_cookie_consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => { if (!localStorage.getItem(KEY)) setShow(true); }, 900);
    return () => clearTimeout(t);
  }, []);
  const dismiss = (v) => { localStorage.setItem(KEY, v); setShow(false); };

  return (
    <AnimatePresence>
      {show && (
        <motion.div data-testid="cookie-consent"
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 left-4 right-4 z-[80] mx-auto max-w-md border border-white/10 bg-ink/95 p-5 text-white backdrop-blur-xl sm:right-auto">
          <p className="text-sm leading-relaxed text-white/75">
            We use only the essential cookies needed to run this site. See our{" "}
            <Link to="/cookies" className="text-champagne underline-offset-4 hover:underline">cookie policy</Link>.
          </p>
          <div className="mt-4 flex items-center gap-3">
            <button data-testid="cookie-accept" onClick={() => dismiss("accepted")}
              className="bg-champagne px-5 py-2.5 text-[10px] uppercase tracking-label text-ink transition-colors duration-300 hover:bg-champagne-soft">Accept</button>
            <button data-testid="cookie-dismiss" onClick={() => dismiss("dismissed")}
              className="px-3 py-2.5 text-[10px] uppercase tracking-label text-white/60 transition-opacity hover:opacity-100">Dismiss</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
